module.exports = __webpack_public_path__ + "static/media/3.f34ea993.jpg";